import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxurious%20dark%20golden%20abstract%20background%20with%20flowing%20elegant%20lines%2C%20warm%20amber%20and%20dark%20tones%2C%20premium%20luxurious%20texture%2C%20soft%20dramatic%20lighting%2C%20no%20text%2C%20sophisticated%20art%20decoration%20style&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="壹号娱乐顶级娱乐体验平台"
        title="壹号娱乐顶级娱乐体验平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <i className="ri-sparkling-2-fill text-primary-300 text-sm"></i>
            <span className="text-white/90 text-sm font-medium">2026夏季狂欢节火热进行中</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight">
            顶级娱乐体验
            <br />
            <span className="text-primary-300">尽在壹号娱乐</span>
          </h1>

          <p className="text-white/75 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            壹号娱乐为您提供多元化娱乐内容与极致体验服务。无论您追求刺激游戏、精彩活动还是优质会员权益，这里都能满足您的一切娱乐需求。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-base whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer w-full sm:w-auto"
            >
              立即注册
            </Link>
            <Link
              to="/category/live-casino"
              className="px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-semibold text-base whitespace-nowrap hover:bg-white/10 transition-colors duration-200 cursor-pointer w-full sm:w-auto"
            >
              探索娱乐
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 mt-12">
            {[
              { value: '500万+', label: '注册用户' },
              { value: '1000+', label: '游戏项目' },
              { value: '99.9%', label: '用户满意度' },
              { value: '7×24h', label: '全天候服务' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-white/60 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}